export default function About() {
  return (
    <section id="about" className="relative py-32 bg-white">
      <div className="px-8 lg:px-24">
        <div className="flex justify-end mb-12">
          <span className="text-sm uppercase tracking-widest text-gray-400">/expertise</span>
        </div>

        <div className="max-w-5xl">
          <p className="text-4xl lg:text-5xl font-light leading-relaxed text-gray-900 mb-16">
            SOMA d.o.o. is a team of experts developing modern applications for the iOS platform. 
            Our products, such as VPN and Cleaner, are designed to enhance user experience and 
            improve the security of mobile devices.
          </p>

          <div className="flex items-center gap-6">
            <div className="flex items-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-green-500 flex items-center justify-center text-white text-2xl font-semibold">
                A
              </div>
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-400 to-blue-500 flex items-center justify-center text-white text-2xl font-semibold -ml-5">
                B
              </div>
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-400 to-purple-500 flex items-center justify-center text-white text-2xl font-semibold -ml-5">
                C
              </div>
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-pink-400 to-pink-500 flex items-center justify-center text-white text-2xl font-semibold -ml-5">
                D
              </div>
            </div>
            <p className="text-lg font-medium text-gray-700">Expert iOS Development Team</p>
          </div>
        </div>
      </div>
    </section>
  );
}